<template>
    <div class="c-programmes-search" :class="[background]">
        <div class="o-container">
            <div class="o-form -form-preload" :class="{ '-loading': loading }">

                <div class="c-loading__inner -search">
                    <div class="c-loading">
                        <svg class="c-loading__svg" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <path class="c-loading__letters"
                                    d="M50.2,58.4c-0.6,0-1.7,0.1-3.1,0.2c-0.3,0-0.6,0-0.9,0.1l-1.8,7.4h5.9l2-7.9C51.5,58.3,50.8,58.4,50.2,58.4" />
                                <path class="c-loading__letters" d="M80.7,53.3c-1.2,0.4-2.5,0.8-4,1.2c-0.4,0.1-0.9,0.2-1.3,0.3c-0.2,0-0.3,0.1-0.5,0.1c0,0.2,0,0.4,0,0.6
                                    c0,2.5-1.6,5.1-5.2,5.1c-2.4,0-4.7-1-6.8-3.1l-0.4-0.4l-0.1,0.6L61,62.7L61,62.9l0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.3
                                    c2.5,1.4,5.3,2.1,8.2,2.1c7.2,0,11-5.1,11-10.1C80.9,54.6,80.8,53.9,80.7,53.3" />
                            </g>
                            <circle class="c-loading__circle" cx="50" cy="50" r="40" stroke="url(#gradient)"
                                stroke-width="5" fill="none" />
                            <defs>
                                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0%" style="stop-color:#E40032;stop-opacity:1" />
                                    <stop offset="100%" style="stop-color:#ffffff;stop-opacity:1" />
                                </linearGradient>
                            </defs>
                            <g>
                                <path class="c-loading__letters"
                                    d="M40.8,38.1H23.2l-7.9,31.7h17.8l1.2-4.9H22.4l2.3-9.1h10.1l1.2-4.9H25.9l2-7.9h11.7L40.8,38.1z" />
                                <path class="c-loading__letters"
                                    d="M39.1,30.3c-0.7,0-1.4,0.4-2.7,1.1l-0.1,0.1L30,35.2l-0.9,0.5l1,0.1l1.4,0.1h0.1l0.1,0l7.1-2.2
                                    c0.8-0.2,1.6-0.5,1.9-1.4c0.1-0.4,0-0.8-0.2-1.2c-0.2-0.4-0.5-0.6-0.9-0.8C39.4,30.3,39.2,30.3,39.1,30.3" />
                                <path class="c-loading__letters" d="M43.3,34.5l-1.2,4.9H51l-0.2,0.8l-4,16.2c0.3,0,0.6,0,0.9-0.1c1-0.1,1.9-0.1,2.3-0.2c0.9-0.1,1.8-0.2,2.8-0.2
                                    l4.1-16.5h8.3l1-4.1l0.2-0.8L43.3,34.5L43.3,34.5z" />
                                <path class="c-loading__letters" d="M84.5,34.4c-2.9-1.7-5.7-2.1-7.5-2.1c-3,0-5.7,1-7.5,2.9c-1.7,1.7-2.6,4.1-2.6,6.5c0,2.8,1.2,4.8,2.7,6.4
                                    c0.7,0.8,1.5,1.5,2.2,2.1c0.7,0.6,1.3,1.3,1.9,2c0.1,0.2,0.3,0.4,0.4,0.6c0,0,0.1,0,0.1,0c0.6-0.2,1.3-0.3,1.9-0.5
                                    c1.4-0.4,2.7-0.7,3.8-1.1c-0.3-0.6-0.7-1.1-1.1-1.6c-0.6-0.7-1.2-1.3-1.7-1.9l0,0l-0.9-0.9c-0.5-0.4-1-0.9-1.5-1.4
                                    c-1-1.1-1.9-2.4-1.9-3.9c0-2.1,1.6-4.4,4.6-4.4c1.1,0,3.3,0.3,5.6,2.5l0.4,0.4l0.1-0.5l1.1-4.5l0-0.1l0.1-0.2L84.5,34.4L84.5,34.4z
                                    " />
                            </g>
                        </svg>
                    </div>
                </div>

<!-- {{ domains }} -->
<!-- {{ labs }} -->
                <h2 class="o-title-4" v-if="title != ''" v-html="title">
                </h2>
                <div class="o-form__item__container">
                    <div v-if="prof == 0" class="o-form__item">
                        <label class="o-label" for="equipement-search">{{ t("Mots clés") }}</label>
                        <input @keyup="keyupSearch()" class="o-input" id="equipement-search" type="text"
                            :placeholder='t("Nom, prénom, téléphone, poste, local")' v-model="searchInput">
                    </div>
                    <div v-else class="o-form__item">
                        <label class="o-label sr-only" for="equipement-search">{{ t("Mots clés") }}</label>
                        <input @keyup="keyupSearch()" class="o-input" id="equipement-search" type="text"
                            :placeholder='t("Mots clés")' v-model="searchInput">
                        <svg class="o-ico -ico-search" role="img">
                            <title>search</title>
                            <use xlink:href="/assets/img/sprite.svg?v=5#search"></use>
                        </svg>
                    </div>
                    <div v-if="domains.length" class="o-form__item">
                        <label class="o-label sr-only" for="domains">{{ t("Domaines") }}</label>
                        <select @change="changeSelectionDomain()" class="o-select" id="domains"
                            v-model="selectedDomain">
                            <option value="" v-html="t(`Domaines`)"></option>
                            <option v-for="domain in domains" :value="domain.id">{{ domain.title }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=5#arrow-down"></use>
                        </svg>
                    </div>
                    <div v-if="categories.length" class="o-form__item">
                        <label class="o-label sr-only" for="categories">{{ t("Catégories") }}</label>
                        <select @change="changeSelectionCategory()" class="o-select" id="categories"
                            v-model="selectedCategory">
                            <option value="" v-html="t(`Catégories`)"></option>
                            <option v-for="category in categories" :value="category.id">{{ category.title }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=5#arrow-down"></use>
                        </svg>
                    </div>

                    <!-- <div v-if="labs.length" class="o-form__item">
                        <label class="o-label sr-only" for="labs">{{ t("Laboratoires") }}</label>
                        <select @change="changeSelectionAxe()" class="o-select" id="labs" v-model="selectedLab">
                            <option value="">{{ t("Laboratoire") }}</option>
                            <option v-for="lab in labs" :value="lab.id">{{ lab.title }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=5#arrow-down"></use>
                        </svg>
                    </div> -->
                    <div class="o-form__button c-tooltip__wrap">
                        <button v-if="target" @click.prevent="refreshUrlQuery()" class="o-button -button-bg"
                            type="submit">
                            <span class="o-button__icos">
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=5#arrow-full-right"></use>
                                    </svg>
                                </span>
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=5#arrow-full-right"></use>
                                    </svg>
                                </span>
                            </span>
                            <span class="o-button__text">
                                <span class="o-button__text__elm">
                                    {{ t("Rechercher") }}
                                    <span v-if="!prof" class="sr-only">
                                        {{ t("une personne selon les critères sélectionnés") }}
                                    </span>
                                    <span v-else class="sr-only">
                                        {{ t("un professeur selon les critères sélectionnés") }}
                                    </span>
                                </span>
                            </span>
                        </button>

                        <div class="c-tooltip">
                            <span v-if="!target" class="c-tooltip__text">
                                {{ t("Voir les") }} {{ filteredResults.length }} {{ t("résultat") }}{{
                                    filteredResults.length > 1 ? 's' : '' }}
                            </span>
                            <span v-else class="c-tooltip__text">
                                {{ t("Voir les") }} {{ t("résultats") }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="c-search-filters-results" :class="{ '-loading': loading }">
    <!-- <div class="c-search-filters-results" :class="{ '-loading': loading, '-noresults': filteredResults.length === 0 }"> -->
        <div v-if="filteredResults.length || tags.length || searchInput.length >= 3 || selectedLabs.length || selectedDomains.length || selectedCategories.length"
            class="c-programmes-search__filters">
            <div class="o-container">
                <div class="c-programmes-search__filters__wrap">
                    <div v-if="!target && (searchInput.length >= 3 || selectedLabs.length > 0 || selectedDomains.length > 0 || selectedCategories.length > 0)"
                        class="c-programmes-search__filters__total">
                        <span>
                            {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                        </span>
                    </div>
                    <div v-if="tags.length" class="c-programmes-search__filters__actives">
                        <div v-for="tag in tags" class="c-programmes-search__filters__actives__item">
                            <span>
                                {{ tag.title }}
                            </span>
                            <button @click.prevent="removeTag(tag)" class="c-programmes-search__filters__remove">
                                <span></span>
                                <span></span>
                                <span class="sr-only">{{ t("Retirer le filtre") }} : {{ tag.title }}</span>
                            </button>
                        </div>
                    </div>
                    <div v-if="!target && (tags.length > 0 || searchInput.length >= 3)"
                        class="c-programmes-search__filters__reset">
                        <button @click.prevent="resetSearch()" class="o-button -button-reset">
                            {{ t("Réinitialiser la recherche") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div ref="resultsStart"></div>

        <div class="o-section__inner">
            <div class="o-container">
                <div class="o-grid o-people -grid-no-row-gap">
                    <template v-for="entry in filteredResultsPaged">
                        <div class="o-grid-4 o-people__item c-tooltip__wrap"
                            @click="openModal($event, entry)"
                        >

                            <div class="o-people__item__strokes"></div>
                                
                            <!-- <div class="o-people__img" v-if="entry.photo" v-html="entry.photo"></div> -->
                            <div class="o-people__img">
                                <span class="o-responsive-img -fit -center-center" style="padding-top:100%;" v-if="!entry.photo">
                                    <img class="o-img -fit -center-center" src="/assets/img/placeholder.jpeg" alt="No image" />
                                </span>
                                <span v-else v-html="entry.photo"></span>

                                <template v-if="entry.description && entry.description!=''">
                                    <!-- <span v-html="entry.description"></span> -->

                                    <button class="c-tooltip__indicator">
                                        <span></span>
                                        <span></span>
                                    </button>
                                    <dialog class="c-modal" data-lenis-prevent @click.stop="closeModal($event)">
                                        <button class="c-modal__close" autofocus>
                                            <span></span>
                                            <span></span>
                                        </button>
                                        <div class="c-modal__content">
                                            <div class="c-modal__item is-active">
                                                <div class="c-modal__text">
                                                    <h3 class="o-title-4">{{ entry.title }}</h3>
                                                    <div v-html="entry.description"></div>
                                                    <a @click.stop :href="entry.url" class="o-button o-box-cta__btn -button-text" target="_self" rel="">
                                                        <span class="o-button__icos">
                                                            <span class="o-button__ico">
                                                                <svg class="o-ico -ico-arrow-full-right" aria-hidden="true" tabindex="-1" role="img">
                                                                    <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                                                </svg>
                                                    
                                                            </span>
                                                            <span class="o-button__ico">
                                                                <svg class="o-ico -ico-arrow-full-right" aria-hidden="true" tabindex="-1" role="img">
                                                                    <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                                                </svg>
                                                            </span>
                                                        </span>
                                                        <span class="o-button__text">
                                                            <span class="o-button__text__elm">
                                                                {{ t('Voir la fiche complète') }}
                                                                <span class="sr-only">{{ t("Fiche complète de l'équipement") }}</span>
                                                            </span>
                                                        </span>
                                                    
                                                    </a>

                                                </div>
                                            </div>
                                        </div>
                                    </dialog>

                                </template>

                            </div>
                            
                            <h3 class="o-title-4 o-people__name">
                                <span>{{ entry.title }}</span>
                            </h3>

                            <p class="o-people__role">
                                {{ entry.domaines.map(domaine => domaine.title).join(', ') }}
                            </p>
                            <p v-for="(lab, lindex) in entry.labs" :key="lindex">
                                {{ lab.title }}
                            </p>

                            <a @click.stop :href="entry.url" class="o-button o-box-cta__btn -button-text" target="_self" rel="">
                                <span class="o-button__icos">
                                    <span class="o-button__ico">
                                        <svg class="o-ico -ico-arrow-full-right" aria-hidden="true" tabindex="-1" role="img">
                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                        </svg>

                                    </span>
                                    <span class="o-button__ico">
                                        <svg class="o-ico -ico-arrow-full-right" aria-hidden="true" tabindex="-1" role="img">
                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                        </svg>
                                    </span>
                                </span>
                                <span class="o-button__text">
                                    <span class="o-button__text__elm">
                                        {{ t('Voir la fiche complète')}}
                                        <span class="sr-only">{{ t("Fiche complète de l'équipement") }}</span>
                                    </span>
                                </span>

                            </a>
                        </div>
                    </template>
                </div>
                <Pager v-if="pagerInfo.totalPages > 1" :pagerInfo="pagerInfo" @goToPage="goToPage" />
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'debounce';
import Pager from './Pager.vue';

export default {
    props: {
        background: {
            type: String,
            default: ''
        },
        // prof: {
        //     type: Boolean,
        //     default: 0
        // },
        canChangeUrl: {
            type: Boolean,
            default: true
        },
        target: {
            type: String,
            default: false
        }
    },
    components: {
        Pager
    },
    data() {
        return {
            siteId: 1,
            loading: false,
            searchInput: '',
            searchedIds: null,
            selectedLab: '',
            selectedDomain: '',
            selectedCategory: '',
            selectedLabs: [],
            selectedDomains: [],
            selectedCategories: [],
            // labs: [],
            results: [],
            controller: null,
            pagerInfo: {
                currentPage: 1,
                totalPages: 1
            },
            languageUrl: '/',
            labs: this.$root.labs || [],
            domains: this.$root.domains || [],
            categories: this.$root.categories || [],
            title: this.$root.title || '',
            searchTo: null,
        }
    },
    mounted() {
        // console.log('PROF', this.categories)
        let lang = document.documentElement.lang;
        if (lang === 'fr-CA') {
            this.siteId = 1;
        } else {
            this.siteId = 2;
            this.languageUrl = '/en/';
        }

        //load query params
        const currentUrl = new URL(window.location.href);
        const query = currentUrl.search;
        const urlParams = new URLSearchParams(query);
        if (urlParams.has('labs')) {
            this.selectedLabs = urlParams.get('labs').split(',').map(id => parseInt(id));
        }
        if (urlParams.has('domains')) {
            this.selectedDomains = urlParams.get('domains').split(',').map(id => parseInt(id));
        }
        if (urlParams.has('categories')) {
            this.selectedCategories = urlParams.get('categories').split(',').map(id => parseInt(id));
        }
        if (urlParams.has('s')) {
            this.searchInput = urlParams.get('s');
        }
        this.fetchAttributes();
        if (this.searchInput.length >= 3) this.search();
        //console.log(ProjectLocalisation["Mots clés"])
    },
    watch: {
        searchInput(newValue) {
            if (newValue.length >= 3) {

                clearTimeout(this.searchTo);

                this.searchTo = setTimeout(() => {
                    if (this.controller) this.controller.abort();

                    this.loading = true;
                    this.search();
                }, 500);
            } else {
                this.refreshUrlQuery()
            }
        },
    },
    computed: {
        filteredResults() {
            let filtered = this.results;

            if (this.prof && this.searchInput.length < 3 && this.selectedLabs.length == 0 && this.selectedDomains.length == 0 && this.selectedCategories.length == 0) {
                this.pagerInfo.currentPage = 1;
                this.pagerInfo.totalPages = 1;
                return [];
            }

            if (this.searchedIds !== null && this.searchedIds.length > 0) {
                if (this.searchedIds.length === 0) return [];
                filtered = filtered.filter(entry => {
                    return this.searchedIds.includes(entry.id);
                });

                filtered.sort((a, b) => {
                    return this.searchedIds.indexOf(a.id) - this.searchedIds.indexOf(b.id);
                });
            }
            if (this.searchedIds !== null && this.searchedIds.length == 0 && this.searchInput.length >= 3) {
                filtered = [];

            }

            if (this.selectedLabs.length) {
                filtered = filtered.filter(entry => {
                    return this.selectedLabs.some(lab => {
                        return entry.labs.some(l => l.id == lab);
                    });
                });
            }
            if (this.selectedDomains.length) {
                filtered = filtered.filter(entry => {
                    return this.selectedDomains.some(domain => {
                        return entry.domaines.some(domaine => domaine.id == domain);
                    });
                });
            }
            if (this.selectedCategories.length) {
                filtered = filtered.filter(entry => {
                    return this.selectedCategories.some(category => {
                        return entry.categories.some(categorie => categorie.id == category);
                    });
                });
            }

            this.pagerInfo.totalPages = Math.ceil(filtered.length / 12);
            this.pagerInfo.currentPage = 1;
            if (this.selectedDomains.length && this.selectedDomains[0] === 'Service des ressources humaines') {
                // Set entry with ID 392433 as the first element
                const entry = filtered.find(e => e.id === 392433);
                if (entry) {
                    filtered = [entry, ...filtered.filter(e => e.id !== 392433)];
                }
            }
            return filtered;
        },
        filteredResultsPaged() {
            return this.filteredResults.slice((this.pagerInfo.currentPage - 1) * 12, this.pagerInfo.currentPage * 12);
        },
        tags() {
            let tags = [];
            // console.log(this.selectedLabs, this.selectedDomains);
            this.selectedLabs.forEach(lab => tags.push({ type: 'lab', title: this.labs.find(l => l.id === lab)?.title ?? lab, id: lab }));
            this.selectedDomains.forEach(domain => tags.push({ type: 'domain', title: this.domains.find(d => d.id === domain)?.title ?? domain, id: domain }));
            this.selectedCategories.forEach(category => tags.push({ type: 'category', title: this.categories.find(c => c.id === category)?.title ?? category, id: category }));
            return tags
        }
    },
    methods: {
        openModal(event, entry) {
            const modal = event.currentTarget.querySelector('dialog');
            if (modal) {
                modal.showModal();
            } else if (entry && entry.url) {
                window.location.href = entry.url;
            }
        },
        closeModal(event) {
            console.log(event)
            const modal = event.target.closest('dialog');

            modal.setAttribute("closing", "");

            modal.addEventListener(
                "animationend",
                () => {
                    modal.removeAttribute("closing");
                    modal.close();
                    // this.parent.classList.remove("is-active");
                },
                { once: true }
            );

            // if (modal) {
            //     modal.closeDialog();
            // }
        },
        t(string) {
            return decodeURI(EquipmentLocalisation[string]);
        },
        fetchAttributes() {
            this.loading = true;
            fetch(this.languageUrl + 'api/search/equipement-index?siteId=' + this.siteId, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.labs !== undefined) this.labs = data.labs;
                    if (data.domains !== undefined) this.domains = data.domains;
                    if (data.categories !== undefined) this.categories = data.categories;
                    if (!this.target && data.results !== undefined) this.results = data.results;

                    this.pagerInfo.totalPages = Math.ceil(this.results.length / 12);
                    this.loading = false;
                })
        },
        goToPage(page) {
            setTimeout(() => {
                this.pagerInfo.currentPage = page;
                this.$refs.resultsStart.scrollIntoView({ behavior: 'smooth' });
            }, 500);
        },
        changeSelectionAxe() {
            let current = this.selectedLab;
            if (current === '') return;
            if (!this.selectedLabs.includes(current)) {
                this.selectedLabs.push(current);
            }
            this.selectedLab = '';
            if (this.canChangeUrl && !this.target) this.refreshUrlQuery();
        },
        changeSelectionDomain() {
            let current = this.selectedDomain;
            if (current === '') return;
            if (!this.selectedDomains.includes(current)) {
                this.selectedDomains.push(current);
            }
            this.selectedDomain = '';
            if (this.canChangeUrl && !this.target) this.refreshUrlQuery();
        },
        changeSelectionCategory() {
            let current = this.selectedCategory;
            if (current === '') return;
            if (!this.selectedCategories.includes(current)) {
                this.selectedCategories.push(current);
            }
            this.selectedCategory = '';
            if (this.canChangeUrl && !this.target) this.refreshUrlQuery();
        },
        removeTag(tag) {
            if (tag.type === 'lab') {
                this.selectedLabs = this.selectedLabs.filter(lab => lab !== tag.id);
            }
            if (tag.type === 'domain') {
                this.selectedDomains = this.selectedDomains.filter(domain => domain !== tag.id);
            }
            if (tag.type === 'category') {
                this.selectedCategories = this.selectedCategories.filter(category => category !== tag.id);
            }
            if (this.target) return;
            if (this.canChangeUrl && !this.target) this.refreshUrlQuery();
        },
        keyupSearch: debounce(function (e) {
            // if (this.controller) this.controller.abort();
            if (this.searchInput.length >= 3) {
                if (this.target) return;
                // this.search();
            } else {
                this.searchedIds = null;
            }
        }, 500),
        search() {
            if (this.target) return;
            this.loading = true;
            if (this.controller) {
                this.controller.abort();
            }

            this.controller = new AbortController();

            fetch(this.languageUrl + 'api/search/equipement?s=' + this.searchInput + '&siteId=' + this.siteId, {
                signal: this.controller.signal,
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    this.searchedIds = data;
                    this.loading = false;
                    if (this.canChangeUrl) this.refreshUrlQuery();
                })
                .catch(err => {
                    this.searchedIds = null;
                    this.searchInput = '';
                    this.loading = false;
                    if (this.canChangeUrl) this.refreshUrlQuery();
                });
        },
        refreshUrlQuery() {
            let query = '';
            if (this.selectedLabs.length > 0) {
                query += 'labs=' + this.selectedLabs.join(',') + '&';
            }
            if (this.selectedDomains.length > 0) {
                query += 'domains=' + this.selectedDomains.join(',') + '&';
            }
            if (this.selectedCategories.length > 0) {
                query += 'categories=' + this.selectedCategories.join(',') + '&';
            }
            if (this.searchInput) {
                query += 's=' + this.searchInput;
            }
            const currentUrl = new URL(window.location.href);
            let pathName = currentUrl.pathname;
            pathName = pathName.replace(/(p\d)/, '');
            let newUrl = currentUrl.origin + pathName + '?' + query;
            if (this.target) {
                newUrl = this.target + '?' + query;
                window.location.href = newUrl;
            }
            window.history.pushState({ path: newUrl }, '', newUrl);
        },
        resetSearch() {
            this.searchInput = '';
            this.searchedIds = null;
            this.selectedLabs = [];
            this.selectedDomains = [];
            this.selectedCategories = [];
            if (this.canChangeUrl) this.refreshUrlQuery();
        }
    },
}
</script>
